import { TooltipProvider } from "@/components/ui/tooltip"

import type { ReactNode } from 'react'
import { Helmet } from 'react-helmet-async'

interface AIShellProps {
  children: ReactNode
}

export function AIShell({ children }: AIShellProps) {
  return (
    <>
      <Helmet>
        <title>Rosewood AI | Tax Assistant</title>
        <meta
          name="description"
          content="Chat with Rosewood AI — your intelligent Kenya tax compliance assistant."
        />
      </Helmet>

      <div className="h-screen w-screen overflow-hidden bg-white flex">
           <TooltipProvider>
            {children}
        </TooltipProvider>
      </div>
    </>
  )
}